import { useEffect, useState } from 'react';
export const useSelect = ({ value, defaultValue, options, onChange, isMultiple = false, }) => {
    const [optionList, setOptionList] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isLoading, setLoading] = useState(false);
    useEffect(() => {
        if (typeof options === 'function') {
            setLoading(true);
            options().then((data) => {
                setOptionList(data);
                setLoading(false);
            });
        }
        else {
            setOptionList(options !== null && options !== void 0 ? options : []);
        }
    }, [options]);
    useEffect(() => {
        var _a;
        const val = value || defaultValue;
        if (!val || optionList.length === 0) {
            setSelectedOption(null);
        }
        if (isMultiple && Array.isArray(val)) {
            setSelectedOption(optionList.filter((item) => val.includes(item.value)));
        }
        else if (!isMultiple && !Array.isArray(val)) {
            setSelectedOption((_a = optionList.find((item) => item.value === val)) !== null && _a !== void 0 ? _a : null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, defaultValue, optionList]);
    const updateSelect = (option) => {
        if (!isMultiple && !Array.isArray(selectedOption) && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) !== option.value) {
            setSelectedOption(option);
            onChange && onChange(option.value, option);
        }
        else if (isMultiple) {
            if (!selectedOption) {
                setSelectedOption([option]);
                onChange && onChange([option.value], [option]);
                return;
            }
            else if (Array.isArray(selectedOption)) {
                const index = selectedOption.findIndex((item) => item.value === option.value);
                if (index > -1) {
                    const newSelectedOption = [...selectedOption];
                    newSelectedOption.splice(index, 1);
                    setSelectedOption(newSelectedOption);
                    onChange &&
                        onChange(newSelectedOption.map((item) => item.value), newSelectedOption);
                }
                else {
                    setSelectedOption([...selectedOption, option]);
                    onChange &&
                        onChange([...selectedOption, option].map((item) => item.value), [...selectedOption, option]);
                }
            }
        }
    };
    return {
        isLoading,
        optionList,
        selectedOption,
        updateSelect,
    };
};
